
import {
  defineComponent, onBeforeMount, reactive, ref,
} from 'vue';
import { Card } from 'ant-design-vue';
import TituloPadrao from '@/core/components/Tela/TituloPadrao.vue';
import { IDTODadosEmpresa } from '@/models/DTO/MeuSistema/Empresas/IDTODadosEmpresa';
import { useTelaBase } from '@/core/composables/TelaBase';
import ServicoSistema from '@/servicos/MeuSistema/ServicoSistema';
import SelecionarTipoNotaFiscal from '@/components/Fiscal/SelecionarTipoNotaFiscal.vue';
import { useGradeBase } from '@/core/composables/GradeBase';
import { IDTONotaFiscal } from '@/models/DTO/Fiscal/NotasFiscais/IDTONotaFiscal';
import ServicoNotaFiscal from '@/servicos/Fiscal/ServicoNotaFiscal';
import { IFiltroGenerico } from '@/core/models/BuscaAvancada/IFiltroGenerico';
import { EFiltroPeriodoMovimentoComercial } from '@/models/Enumeradores/Compartilhados/EFiltroPeriodoMovimentoComercial';
import UtilitarioData from '@/core/utilitarios/UtilitarioData';
import { IParametrosConsultaNotaFiscal } from '@/models/ParametrosRequisicao/Fiscal/IParametrosConsultaNotaFiscal';
import { ECustomRenderRow, IColumn } from '@/core/models/AntDesign/IColumn';
import UtilitarioMascara from '@/core/utilitarios/UtilitarioMascara';
import { EEmitenteDocumentoFiscal } from '@/models/Enumeradores/Fiscal/EEmitenteDocumentoFiscal';
import storeSistema from '@/store/storeSistema';
import Icone from '@/core/components/Icone.vue';
import SelecionarStatusNotaEmitida from '@/components/Fiscal/SelecionarStatusNotaEmitida.vue';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import PreviewPdf from '@/core/components/Modal/PreviewPdf.vue';
import { IArquivoPdf } from '@/core/models/IArquivoPdf';
import EnviarEmailPessoaModal from '@/components/Cadastros/Pessoas/EnviarEmailPessoaModal.vue';
import { IRetornoComunicacaoDFe } from '@/core/models/IRetornoComunicacaoDFe';
import SelecionarFiltroPeriodoMovimentoComercial from '@/components/Compartilhados/SelecionarFiltroPeriodoMovimentoComercial.vue';
import SelecionarDataInicialFinal from '@/core/components/Tela/SelecionarDataInicialFinal.vue';

export default defineComponent({
  name: 'CentralNotasFiscais',
  components: {
    TituloPadrao,
    Card,
    Icone,
    SelecionarStatusNotaEmitida,
    SelecionarTipoNotaFiscal,
    SelecionarFiltroPeriodoMovimentoComercial,
    PreviewPdf,
    EnviarEmailPessoaModal,
    SelecionarDataInicialFinal,
  },
  setup(props) {
    const dadosEmpresa = ref<IDTODadosEmpresa>({} as IDTODadosEmpresa);
    const {
      telaBase, preencherEmpresasDisponiveis, filtrarPermissaoDadosUsuarioMultiEmpresas,
      apresentarMensagemSucesso, apresentarMensagemAlerta,
    } = useTelaBase();
    const { gradeBase, defineAlturaScroll } = useGradeBase();
    const servicoNotaFiscal = new ServicoNotaFiscal();
    const permissaoServico = ref<boolean>({} as boolean);

    const state = reactive({
      identificadorRecurso: 'CENTRAL_NOTAS_FISCAIS',
      tituloRecurso: 'Central de Notas Fiscais Emitidas',
      carregandoTela: true,
      tipoNotaFiscal: 0,
      statusNotaFiscal: 2,
      periodo: 1,
      notasFiscais: [] as IDTONotaFiscal[],
      filtros: [] as IFiltroGenerico[],
      dataInicialSelecionada: '',
      dataFinalSelecionada: '',
      filtroPeriodo: 0,
      dataAtual: '',
      empresaSelecionada: 42,
      colunas: [] as IColumn[],
      telaMobile: false,
      selecionados: [] as number[],
      qtdSelecionados: 0,
      qtdSelecionadosAutorizadas: 0,
      qtdSelecionadosConcluir: 0,
      qtdSelecionadosCancelar: 0,
      qtdSelecionadosExcluir: 0,
      qtdSelecionadosRetomar: 0,
      arquivosPdf: [] as IArquivoPdf[],
      apresentarEnvioEmail: false,
      codigoPessoaEmail: 0,
      notaFiscalEnvioEmail: {} as IDTONotaFiscal,
      notasFiscaisSelecionadas: [] as IDTONotaFiscal[],
    });

    function preencherColunas() {
      if (state.telaMobile) {
        state.colunas = [
          {
            title: 'Código', dataIndex: 'codigo', key: 'Codigo', position: 1, visible: false,
          },
          {
            title: 'NF', dataIndex: 'notaFiscal', key: 'NotaFiscal', position: 2, visible: true, ellipsis: true,
          },
        ];
      } else {
        state.colunas = [
          {
            title: 'Código', dataIndex: 'codigo', key: 'Codigo', position: 1, visible: false, ordering: true, fixed: 'left',
          },
          {
            title: 'Nº', dataIndex: 'numero', key: 'Numero', position: 2, visible: true, ordering: true, fixed: 'left', width: 75,
          },
          {
            title: 'Dt de Emissão', dataIndex: 'dataEmissao', key: 'DataEmissao', position: 3, visible: true, ordering: true, customRenderRow: ECustomRenderRow.MascararData, width: 120, align: 'center',
          },
          {
            title: 'Pessoa', dataIndex: 'nomeRazaoSocialDestinatario', key: 'nomeRazaoSocialDestinatario', position: 4, visible: true, ordering: true, width: 300,
          },
          {
            title: 'Valor Total', dataIndex: 'totalNotaFiscal', key: 'TotalNotaFiscal', position: 5, visible: true, ordering: true, customRenderRow: ECustomRenderRow.MascararFracionado, align: 'right', width: 100,
          },
          {
            title: 'Chave de Acesso', dataIndex: 'chaveAcesso', key: 'ChaveAcesso', position: 6, visible: true, ordering: true, width: 300, align: 'center',
          },
          {
            title: 'Status', dataIndex: 'descricaoStatus', key: 'Status', position: 7, visible: true, ordering: true, width: 110, align: 'center',
          },
          {
            title: 'Ações', key: 'acoes', position: 8, visible: true, fixed: 'right', width: 100, align: 'center', customRenderRow: ECustomRenderRow.IconeAcoes,
          },
        ];
      }
    }

    function prencheDatasPeriodo() {
      switch (state.periodo) {
        case EFiltroPeriodoMovimentoComercial.Hoje:
          state.dataInicialSelecionada = state.dataAtual;
          state.dataFinalSelecionada = state.dataAtual;
          break;

        case EFiltroPeriodoMovimentoComercial.Ontem:
          state.dataInicialSelecionada = UtilitarioData.diminuirDiaNaData(state.dataAtual, 1);
          state.dataFinalSelecionada = UtilitarioData.diminuirDiaNaData(state.dataAtual, 1);
          break;

        case EFiltroPeriodoMovimentoComercial.SemanaAtual:
          state.dataInicialSelecionada = UtilitarioData.diminuirDiaNaData(state.dataAtual, 7);
          state.dataFinalSelecionada = state.dataAtual;
          break;

        case EFiltroPeriodoMovimentoComercial.MesAtual:
          state.dataInicialSelecionada = UtilitarioData.obterPrimeiroDiaMes(state.dataAtual);
          state.dataFinalSelecionada = UtilitarioData.obterUltimoDiaMes(state.dataAtual);
          break;

        case EFiltroPeriodoMovimentoComercial.AnoAtual:
          state.dataInicialSelecionada = UtilitarioData.obterPrimeiroDiaAno(state.dataAtual);
          state.dataFinalSelecionada = UtilitarioData.obterUltimoDiaAno(state.dataAtual);
          break;

        case EFiltroPeriodoMovimentoComercial.Ultimos15Dias:
          state.dataInicialSelecionada = UtilitarioData.diminuirDiaNaData(state.dataAtual, 15);
          state.dataFinalSelecionada = state.dataAtual;
          break;

        case EFiltroPeriodoMovimentoComercial.Ultimos30Dias:
          state.dataInicialSelecionada = UtilitarioData.diminuirDiaNaData(state.dataAtual, 30);
          state.dataFinalSelecionada = state.dataAtual;
          break;

        case EFiltroPeriodoMovimentoComercial.Ultimos60Dias:
          state.dataInicialSelecionada = UtilitarioData.diminuirDiaNaData(state.dataAtual, 60);
          state.dataFinalSelecionada = state.dataAtual;
          break;

        case EFiltroPeriodoMovimentoComercial.Ultimos90dias:
          state.dataInicialSelecionada = UtilitarioData.diminuirDiaNaData(state.dataAtual, 90);
          state.dataFinalSelecionada = state.dataAtual;
          break;

        default:
      }
    }

    async function obterOrigemNotaFiscal() {
      switch (state.tipoNotaFiscal) {
        case 1:
          return 0;
        case 2:
          return 1;
        case 3:
          return 5;
        case 4:
          return 3;
        case 5:
        case 6:
          return 6;
        default:
          return 8;
      }
    }

    async function buscarNotasFiscais() {
      state.notasFiscais = [];
      state.filtros = [] as IFiltroGenerico[];
      prencheDatasPeriodo();
      const parametrosConsulta = {} as IParametrosConsultaNotaFiscal;
      parametrosConsulta.empresas = [state.empresaSelecionada];
      parametrosConsulta.ordenacao = Array<string>();
      parametrosConsulta.periodo = state.periodo;
      parametrosConsulta.dataInicial = state.dataInicialSelecionada;
      parametrosConsulta.dataFinal = state.dataFinalSelecionada;
      parametrosConsulta.origemNotaFiscal = await obterOrigemNotaFiscal();
      parametrosConsulta.status = state.statusNotaFiscal;
      parametrosConsulta.ordenacao.push('Status', 'DataEmissao|DESC');

      parametrosConsulta.qtdeRegistrosPagina = 1000;

      telaBase.carregando = true;
      const listaPaginada = await servicoNotaFiscal.buscaAvancada(parametrosConsulta, state.filtros);
      state.notasFiscais = listaPaginada.dados;
      telaBase.carregando = false;
    }

    async function atualizarSelecaoEmpresas() {
      telaBase.empresasSelecionadas = [] as number[];
      telaBase.empresasSelecionadas.push(dadosEmpresa.value.codigoEmpresa);
      telaBase.permissaoDados = await filtrarPermissaoDadosUsuarioMultiEmpresas(telaBase.empresasSelecionadas);
      permissaoServico.value = await new ServicoSistema().validarPermissaoModulo(dadosEmpresa.value.codigoEmpresa, 8);
      await buscarNotasFiscais();
    }

    function obterNomeRazaoSocialPessoa(notaFiscal: IDTONotaFiscal) {
      if (notaFiscal.tipoEmissao === EEmitenteDocumentoFiscal.EmissaoPropria) {
        return notaFiscal.nomeRazaoSocialDestinatario;
      }
      return notaFiscal.nomeRazaoSocialEmitente;
    }
    const filtros = ref({
      data: null,
      tipo: null,
      status: null,
    });

    function obterClasseStatus(status: string) {
      switch (status) {
        case 'Pendente':
          return 'em-digitacao';
        case 'Em Processamento':
          return 'aguardando-emissao';
        case 'Autorizada':
          return 'concluido';
        default:
          return 'cancelado';
      }
    }

    async function exportarXMLs() {
      if (UtilitarioGeral.validaLista(gradeBase.codigosSelecionados)) {
        const retorno = await servicoNotaFiscal.baixarXMLs(gradeBase.codigosSelecionados, state.empresaSelecionada);
        if (retorno !== undefined) {
          if (retorno.sucesso) {
            if (UtilitarioGeral.valorValido(retorno.linkPdf)) {
              UtilitarioGeral.downloadArquivo(retorno.linkPdf);
            }
          } else if (UtilitarioGeral.valorValido(retorno.mensagem)) {
            apresentarMensagemAlerta(retorno.mensagem);
          }
        }
      }
    }

    async function exportarXML(codigoNotaFiscal: number) {
      if (UtilitarioGeral.valorValido(codigoNotaFiscal)) {
        const retorno = await servicoNotaFiscal.baixarXML(codigoNotaFiscal, state.empresaSelecionada);
        if (retorno !== undefined) {
          if (retorno.sucesso) {
            if (UtilitarioGeral.valorValido(retorno.linkPdf)) {
              UtilitarioGeral.downloadArquivo(retorno.linkPdf);
            }
          } else if (UtilitarioGeral.valorValido(retorno.mensagem)) {
            apresentarMensagemAlerta(retorno.mensagem);
          }
        }
      }
    }

    async function imprimir(codigoNotaFiscal: number) {
      if (UtilitarioGeral.valorValido(codigoNotaFiscal)) {
        const retorno = await servicoNotaFiscal.visualizar(codigoNotaFiscal);
        if (retorno !== undefined) {
          if (retorno.sucesso) {
            if (UtilitarioGeral.valorValido(retorno.linkPdf)) {
              state.arquivosPdf = [{ nome: '', link: retorno.linkPdf } as IArquivoPdf];
            }
          } else if (UtilitarioGeral.valorValido(retorno.mensagem)) {
            apresentarMensagemAlerta(retorno.mensagem);
          }
        }
      }
    }

    function limparNotaFiscalEnvioEmail() {
      state.codigoPessoaEmail = 0;
      state.notaFiscalEnvioEmail = {} as IDTONotaFiscal;
      state.notaFiscalEnvioEmail.codigo = 0;
      state.notaFiscalEnvioEmail.codigoPessoaDestinatario = 0;
      state.notaFiscalEnvioEmail.numero = 0;
    }

    async function enviarEmailNFe(emails: string []) {
      if (UtilitarioGeral.validaLista(emails)) {
        const retorno:IRetornoComunicacaoDFe = await servicoNotaFiscal.enviarEmail(state.notaFiscalEnvioEmail.codigo, emails);
        if (retorno.sucesso) {
          apresentarMensagemSucesso(retorno.mensagem);
        } else {
          apresentarMensagemAlerta(retorno.mensagem);
        }
      } else {
        apresentarMensagemAlerta('Nenhum e-mail informado para o envio.');
      }
      state.apresentarEnvioEmail = false;
      limparNotaFiscalEnvioEmail();
    }

    function apresentarEnvioEmail(codigo: string) {
      if (UtilitarioGeral.valorValido(codigo)) {
        const notaFiscal = state.notasFiscais.find((c) => c.codigo === Number(codigo));
        if (notaFiscal !== undefined) {
          if (UtilitarioGeral.valorValido(notaFiscal.identificador)) {
            state.notaFiscalEnvioEmail = notaFiscal;
            state.codigoPessoaEmail = notaFiscal.codigoPessoaDestinatario;
            state.apresentarEnvioEmail = true;
          } else {
            state.apresentarEnvioEmail = false;
          }
        }
      }
    }

    async function periodoAlterado() {
      if (state.filtroPeriodo !== EFiltroPeriodoMovimentoComercial.Personalizado) {
        await buscarNotasFiscais();
      }
    }

    const mudarSelecao = (selectedRowKeys: any) => {
      gradeBase.codigosSelecionados = selectedRowKeys;
    };

    onBeforeMount(async () => {
      state.empresaSelecionada = storeSistema.getters.codigoEmpresaOperacao();
      telaBase.identificadorRecurso = state.identificadorRecurso;
      // telaBase.identificadorPermissao = state.identificadorPermissao;
      preencherColunas();
      // await obterPermissoes(ETipoPermissao.Dados);
      await preencherEmpresasDisponiveis();
      // await defineEmpresasSelecionadasComPermissao();
      telaBase.permissaoDados = await filtrarPermissaoDadosUsuarioMultiEmpresas([state.empresaSelecionada]);
      telaBase.propriedadesConsulta = await servicoNotaFiscal.obterPropriedadesConsulta();
      state.dataAtual = await new ServicoSistema().obterDataAtual();

      const dadosEmpresaCache = storeSistema.state.empresasDisponiveis.find((c) => c.codigoEmpresa === storeSistema.getters.codigoEmpresaOperacao());
      if (dadosEmpresaCache !== undefined) {
        dadosEmpresa.value = dadosEmpresaCache;
      }
    });
    return {
      props,
      filtros,
      state,
      dadosEmpresa,
      telaBase,
      atualizarSelecaoEmpresas,
      gradeBase,
      buscarNotasFiscais,
      window,
      obterClasseStatus,
      ECustomRenderRow,
      UtilitarioMascara,
      UtilitarioData,
      obterNomeRazaoSocialPessoa,
      imprimir,
      enviarEmailNFe,
      apresentarEnvioEmail,
      exportarXMLs,
      exportarXML,
      mudarSelecao,
      periodoAlterado,
      EFiltroPeriodoMovimentoComercial,
      defineAlturaScroll,
    };
  },
});
